import { Directive } from '@angular/core';

@Directive({
  selector: '[crmActivityTemplateOptions]',

})
export class CrmActivityTemplateOptionsDirective {}
